var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22292F",
    d: "M13.707 1.707 12.293.293 7 5.586 1.707.293.293 1.707 5.586 7 .293 12.293l1.414 1.414L7 8.414l5.293 5.293 1.414-1.414L8.414 7z"
  })));
};
export { SvgIconClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjcwNyAxLjcwNjk3TDEyLjI5MyAwLjI5Mjk2OUw2Ljk5OTk3IDUuNTg1OTdMMS43MDY5NyAwLjI5Mjk2OUwwLjI5Mjk2OSAxLjcwNjk3TDUuNTg1OTcgNi45OTk5N0wwLjI5Mjk2OSAxMi4yOTNMMS43MDY5NyAxMy43MDdMNi45OTk5NyA4LjQxMzk3TDEyLjI5MyAxMy43MDdMMTMuNzA3IDEyLjI5M0w4LjQxMzk3IDYuOTk5OTdMMTMuNzA3IDEuNzA2OTdaIiBmaWxsPSIjMjIyOTJGIi8+Cjwvc3ZnPgo=";